var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main"},[_vm._v("\n\t© "),_c('strong',[_c('a',{attrs:{"href":"http://sustam.com","target":"_blank"}},[_vm._v("Sustam")])]),_vm._v(" Version 2.0\tUsing "),_c('i',{staticClass:"fab fa-vuejs"}),_vm._v(" and "),_c('i',{staticClass:"fab fa-laravel"})])
}]

export { render, staticRenderFns }